import tailwindConfig from "#tailwind-config";

export const useScreen = () => {
  const { width } = useWindowSize();

  const _isPhablet = useState("_isPhablet");
  const _isTablet = useState("_isTablet");
  const _isLaptop = useState("_isLaptop");
  const _isDesktop = useState("_isDesktop");
  const _isExtDesktop = useState("_isExtDesktop");
  const _calcWidth = useState("_calcWidth");

  const screens = Object.entries(tailwindConfig.theme.screens).reduce(
    (acc, [key, value]) => {
      if (key !== "only-mobile" && key !== "only-smartphone") {
        acc[key] = value.min;
      }
      return acc;
    },
    {}
  );

  function updateScreenSize() {

    if (_calcWidth.value === width.value) {
      return;
    }

    _isPhablet.value = window.matchMedia(`(min-width: ${screens["phablet"]})`).matches;
    _isTablet.value = window.matchMedia(`(min-width: ${screens["tablet"]})`).matches;
    _isLaptop.value = window.matchMedia(`(min-width: ${screens["laptop"]})`).matches;
    _isDesktop.value = window.matchMedia(`(min-width: ${screens["desktop"]})`).matches;
    _isExtDesktop.value = window.matchMedia(`(min-width: ${screens["extdesktop"]})`).matches;
    _calcWidth.value = width.value;
  }

  watch(width, (value) => {
    updateScreenSize();
  });

  onMounted(() => {
    updateScreenSize();
  });

  return {
    isPhablet: computed(() => _isPhablet.value),
    isTablet: computed(() => _isTablet.value),
    isLaptop: computed(() => _isLaptop.value),
    isDesktop: computed(() => _isDesktop.value),
    isExtDesktop: computed(() => _isExtDesktop.value),
  };
};
